import { Navigate, Route, Routes } from "react-router-dom";
import { Chargement } from "./composants/Elements";
import { MiseEnPage } from "./composants/MiseEnPage";
import { PageConnexion } from "./pages/Connexion";
import { PageDossiers } from "./pages/Dossiers";
import { PageDossier } from "./pages/Dossier";
import { PageEcritures } from "./pages/Ecritures";
import { PageGrandLivre } from "./pages/GrandLivre";
import { PageBalance } from "./pages/Balance";
import { PageLettrage } from "./pages/Lettrage";
import { PageFournisseurs } from "./pages/Fournisseurs";
import { PageFactureDAchat } from "./pages/FactureDAchat";
import { PageEcheancier } from "./pages/Echeancier";
import { PageReferentiels } from "./pages/Referentiels";
import { PagePlanDuDossier } from "./pages/PlanDuDossier";
import { PageImport } from "./pages/Import";
import { PageDeclarationsTva } from "./pages/DeclarationsTva";
import { PageBanque } from "./pages/Banque";
import { PageProfil } from "./pages/Profil";
import { PageUtilisateurs } from "./pages/Utilisateurs";
import { PagePlateforme } from "./pages/Plateforme";
import { PageAudit } from "./pages/Audit";
import { PagePlanComptable } from "./pages/PlanComptable";
import { useSession } from "./session";

export function Application() {
  const { session, chargement } = useSession();

  if (chargement) return <Chargement quoi="la session" />;

  // Hors session, toute route mène à l'écran de connexion : l'interface ne
  // laisse pas entrevoir des écrans que le serveur refuserait de toute façon.
  if (session == null) {
    return (
      <Routes>
        <Route path="*" element={<PageConnexion />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<MiseEnPage />}>
        <Route path="/" element={<Navigate to="/dossiers" replace />} />
        <Route path="/dossiers" element={<PageDossiers />} />
        <Route path="/dossiers/:id" element={<PageDossier />} />
        <Route path="/dossiers/:id/ecritures" element={<PageEcritures />} />
        <Route path="/dossiers/:id/grand-livre" element={<PageGrandLivre />} />
        <Route path="/dossiers/:id/balance" element={<PageBalance />} />
        <Route path="/dossiers/:id/lettrage" element={<PageLettrage />} />
        <Route path="/dossiers/:id/plan" element={<PagePlanDuDossier />} />
        <Route path="/dossiers/:id/import" element={<PageImport />} />
        <Route path="/dossiers/:id/tva" element={<PageDeclarationsTva />} />
        <Route path="/dossiers/:id/banque" element={<PageBanque />} />
        <Route path="/dossiers/:id/fournisseurs" element={<PageFournisseurs />} />
        <Route path="/dossiers/:id/facture-achat" element={<PageFactureDAchat />} />
        <Route path="/dossiers/:id/echeancier" element={<PageEcheancier />} />
        <Route path="/referentiels" element={<PageReferentiels />} />
        <Route path="/profil" element={<PageProfil />} />
        <Route path="/administration/utilisateurs" element={<PageUtilisateurs />} />
        <Route path="/plateforme" element={<PagePlateforme />} />
        <Route path="/audit" element={<PageAudit />} />
        <Route path="/plan/:code" element={<PagePlanComptable />} />
        <Route path="*" element={<Navigate to="/dossiers" replace />} />
      </Route>
    </Routes>
  );
}
